export default function useRole() {
    return localStorage.getItem('role');
}
